import { render, staticRenderFns } from "./InputPackageAttribute.vue?vue&type=template&id=25a61092&scoped=true&"
import script from "./InputPackageAttribute.vue?vue&type=script&lang=js&"
export * from "./InputPackageAttribute.vue?vue&type=script&lang=js&"
import style0 from "./InputPackageAttribute.vue?vue&type=style&index=0&id=25a61092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a61092",
  null
  
)

export default component.exports